TYPE_PATCH